import React from "react";
import { Helmet } from "react-helmet-async";

const About = () => {
  return (
    <div className="min-h-screen bg-[#f8f6ef] py-20 px-5 sm:px-8 lg:px-12">

      {/* SEO */}
      <Helmet>
        <title>About Us | Travel Rewards & Points Optimization</title>
        <meta
          name="description"
          content="Learn about our mission to help travelers maximize credit card points, airline miles, and hotel rewards."
        />
        <meta
          name="keywords"
          content="about travel rewards, points optimizer, airline miles guide, credit card rewards"
        />
      </Helmet>

      <div className="max-w-5xl mx-auto">

        {/* Header */}
        <div className="text-center mb-14">
          <h1 className="text-5xl font-black text-slate-primary mb-6">
            About Us
          </h1>

          <p className="text-lg text-slate-600 max-w-2xl mx-auto leading-8">
            We help travelers unlock maximum value from credit card points,
            airline miles, and hotel rewards—so you can travel more for less.
          </p>
        </div>

        {/* Content Card */}
        <div className="bg-white border border-slate-200 rounded-3xl p-10 shadow-sm">

          <h2 className="text-2xl font-black mb-4">
            Our Mission
          </h2>

          <p className="text-slate-700 leading-8 mb-8">
            Our mission is simple: make travel rewards easy, transparent, and profitable
            for every user. Most people lose value on points because they don’t understand
            redemption strategies. We fix that.
          </p>

          <h2 className="text-2xl font-black mb-4">
            What We Do
          </h2>

          <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-8">
            <li>Analyze credit card reward systems</li>
            <li>Compare airline & hotel transfer partners</li>
            <li>Show best redemption strategies</li>
            <li>Help users maximize travel value</li>
          </ul>

          <h2 className="text-2xl font-black mb-4">
            Why Trust Us
          </h2>

          <p className="text-slate-700 leading-8 mb-8">
            We focus on real-world travel data, updated reward systems, and tested
            redemption strategies—not theory. Our goal is to help you travel smarter,
            not harder.
          </p>

          <h2 className="text-2xl font-black mb-4">
            Contact
          </h2>

          <p className="text-slate-700 leading-8">
            Want to collaborate or ask questions?  
            <br />
            Email: <span className="font-bold">jfpcustomersupport@gmail.com</span>
          </p>

        </div>
      </div>
    </div>
  );
};

export default About;